import React, {useContext} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";

const InfoIcon = () => {

  const {
    question
  } = useContext(GettingStartedContext);

  if (!question.Information) {
    return null;
  }

  return <div className="icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="15.728" height="15.728" viewBox="0 0 15.728 15.728">
      <path id="Path_5213" data-name="Path 5213"
            d="M8.518.654a7.864,7.864,0,1,0,7.864,7.864A7.864,7.864,0,0,0,8.518.654Zm.333,3.111A1.034,1.034,0,1,1,7.817,4.8,1.034,1.034,0,0,1,8.851,3.765Zm.927,9.147a1.737,1.737,0,0,1-1.84.168,1.327,1.327,0,0,1-.543-.529,2.031,2.031,0,0,1-.214-1.277l.1-.811.266-2.114-.724.016A.613.613,0,0,1,6.586,7.18l1.856-.731a.859.859,0,0,1,1.114.485.848.848,0,0,1,.038.506l-.025.11-.726,3.187-.181.8a1.748,1.748,0,0,0-.038.21c-.02.359.491.09.491.09a.633.633,0,0,1,.663,1.077Z"
            transform="translate(-0.654 -0.654)" fill="#5ac3ff"/>
    </svg>
  </div>;

}

export default InfoIcon;
